/**
 * @hidden
 */
export const EMPTY_SELECTIONRANGE = { start: null, end: null };
